import { configureFetchDisplayMessages } from './lang/services';
import type { UserSessionHooks, SessionRenewedResult } from './login';
import { loginSlice } from './login/loginSlice';
import { runInBackground } from './setup/backgroundActions';
import { store } from './setup/store';
import { trace } from './setup/trace';
import { accessToken } from './token-handling/accessToken';
import { tokenSlice } from './token-handling/tokenSlice';
import { mapUserProfile } from './login/userProfile';
import { getLanguageFromUrl } from '../data/queryParamsUtils';

export const getUserSessionHooks = (): UserSessionHooks => {
    const fetchDisplayMessages = configureFetchDisplayMessages(store);

    return {
        onSessionExpired: () => {
            trace('oauthConfig: User session expired');
            accessToken.discardAccessToken();
            store.dispatch(tokenSlice.actions.accessTokenStored(null));
            store.dispatch(loginSlice.actions.userSessionExpired());
        },
        onSessionRenewed: (result: SessionRenewedResult) => {
            trace('oauthConfig.onSessionRenewed', result);

            accessToken.saveAccessToken(result.accessToken);
            store.dispatch(tokenSlice.actions.accessTokenStored(result.accessToken));
            store.dispatch(tokenSlice.actions.idTokenStored(result.idToken));
            store.dispatch(loginSlice.actions.userProfileObtained(mapUserProfile(result.profile)));

            store.dispatch(loginSlice.actions.userSessionRenewed());

            // You will need to get the user language yourself then
            // you may fetch the suitable messages. Depending
            // on when and from where you fetch the user settings you might
            // want to employ a loading spinner while the request is ongoing.

            runInBackground(fetchDisplayMessages(getLanguageFromUrl() ?? result.locale));
        },
    };
};
